<template>
    <div>
    <div class="air__utils__heading">
      <h5>Chauffeurs</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">

          <div class="card-body">
            <a-tabs default-active-key="1" @change="callback">
              <a-tab-pane key="1" tab="Shifts">
                <driver-shifts-table />
              </a-tab-pane>
              <a-tab-pane key="2" tab="Chauffeurs">
                <drivers-table />
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import DriverShiftsTable from '@/components/widgets/Drivers/DriverShiftsTable.vue';
import DriversTable from '@/components/widgets/Drivers/DriversTable.vue';

export default {

//   data() {
//     return {
//     }
//   },
  components: {
    DriverShiftsTable,
    DriversTable,
  },
}
</script>
